export const PORTFOLIO = {
  title: 'Portfolio',
  subtitle: 'My',
  typeWriter: ['Best Works', 'Latest Projects'],
  github: 'https://github.com/zobayerhb',
  types: ['All', 'Website', 'App', 'UI/UX Design', 'Graphic Design'],
  projects: [
    {
      title: 'Little Netflix',
      description:
        'Adipisicing Lorem ipsum dolor sit amet, consectetur elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
      video:
        'https://ak.picdn.net/shutterstock/videos/1076130974/preview/stock-footage-diverse-company-employees-having-online-business-conference-video-call-on-tv-screen-monitor-in.mp4',
      images: {
        default: '/Asset/portfolio/netflix.png',
        variants: [
          '/Asset/portfolio/netflix.png',
          '/Asset/portfolio/netflix.png',
        ],
      },
      link: 'https://little-netflix-react.netlify.app',
      type: 'Website',
      tags: ['Web Design', 'Graphic Design', 'Mobile Apps'],
    },
    {
      title: 'Modern HooBank',
      description:
        'Adipisicing Lorem ipsum dolor sit amet, consectetur elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
      video: 'https://vimeo.com/208819209',
      images: {
        default: '/Asset/portfolio/hoobank.jpg',
        variants: [
          '/Asset/portfolio/hoobank.jpg',
          '/Asset/portfolio/hoobank.jpg',
        ],
      },
      link: 'https://modern-hoobank-website.netlify.app',
      type: 'Website',
      tags: ['Web Design', 'Graphic Design', 'Mobile Apps'],
    },
    {
      title: 'Corporate Business site',
      description:
        'Adipisicing Lorem i;psum dolor sit amet, consectetur elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
      video: 'https://www.youtube.com/watch?v=zw7fXtKqTkg',
      images: {
        default: '/Asset/portfolio/megaKit_web.jpg',
        variants: [
          '/Asset/portfolio/megaKit_web',
          '/Asset/portfolio/megaKit_web',
        ],
      },
      link: 'https://megakits-web.netlify.app/',
      type: 'Website',
      tags: ['Web Design', 'Graphic Design', 'Mobile Apps'],
    },
    {
      title: 'Temperature Converter',
      description:
        'Adipisicing Lorem ipsum dolor sit amet, consectetur elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
      video: null,
      images: {
        default: '/Asset/portfolio/temp_converter.png',
        variants: [
          '/Asset/portfolio/temp_converter.png',
          '/Asset/portfolio/temp_converter.png',
        ],
      },
      link: 'https://tempc-c.netlify.app/',
      type: 'App',
      tags: ['Web Design', 'Graphic Design', 'Mobile Apps'],
    },
    {
      title: '1-Click Checkout Zeppto',
      description:
        'Adipisicing Lorem ipsum dolor sit amet, consectetur elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
      video: null,
      images: {
        default: '/Asset/portfolio/zeppto.png',
        variants: [
          '/Asset/portfolio/zeppto.png',
          '/Asset/portfolio/zeppto.png',
        ],
      },
      link: 'https://zeppto-web.netlify.app/',
      type: 'Website',
      tags: ['Web Design', 'Graphic Design', 'Mobile Apps'],
    },
    {
      title: 'portfolio 2.0',
      description:
        'Adipisicing Lorem ipsum dolor sit amet, consectetur elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
      video: null,
      images: {
        default: '/Asset/portfolio/class_portfolio.png',
        variants: [
          '/Asset/portfolio/class_portfolio.png',
          '/Asset/portfolio/class_portfolio.png',
        ],
      },
      link: 'https://class-portfolio-site.netlify.app/',
      type: 'website',
      tags: ['Web Design', 'Graphic Design', 'Mobile Apps'],
    },
  ],
};
